import React from 'react';
import { LabelStyled } from './styles';

export interface Props {
  children: any;
  htmlFor: string;
  optionalText?: string;
}

const Label = ({ children, htmlFor, optionalText }: Props) => {
  const hasOptionalText = !!optionalText;

  return (
    <LabelStyled htmlFor={htmlFor} hasOptionalText={hasOptionalText}>
      {children}
      {hasOptionalText && <span className="optional">{optionalText}</span>}
    </LabelStyled>
  );
};

export default Label;
